"use strict";
/* eslint-disable @typescript-eslint/no-magic-numbers -- default divisor values */
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTokenDivisors = exports.defaultApplicationSpecificTokenDivisors = void 0;
/**
 * Default application-specific token-to-credit divisors.
 * Overrides the general tokenDivisors for autopilot, chat, etc.
 * See TokenUsageApplicationType for application type definitions.
 */
exports.defaultApplicationSpecificTokenDivisors = {
    autopilot: {
        "openAiUsage-o4-mini-2025-04-16-prompt": 18181,
        "openAiUsage-o4-mini-2025-04-16-completion": 4545,
        "openAiUsage-o4-mini-prompt": 18181,
        "openAiUsage-o4-mini-completion": 4545,
        "openAiUsage-gpt-4.1-2025-04-14-prompt": 10000,
        "openAiUsage-gpt-4.1-2025-04-14-completion": 2500,
        "openAiUsage-gpt-4.1-prompt": 10000,
        "openAiUsage-gpt-4.1-completion": 2500,
        "openAiUsage-gpt-5-mini-2025-08-07-prompt": 64516,
        "openAiUsage-gpt-5-mini-2025-08-07-completion": 8064,
    },
    autoPlacement: {},
    autoLayout: {},
    actionsFromChat: {},
    specializedAgent: {}, // @deprecated - kept for backwards compatibility with existing ledger entries
    chat: {
        "openAiUsage-gpt-5-2025-08-07-prompt": 16000,
        "openAiUsage-gpt-5-2025-08-07-completion": 2000,
        "openAiUsage-gpt-5.2-2025-12-11-prompt": 16000,
        "openAiUsage-gpt-5.2-2025-12-11-completion": 2000,
        "openAiUsage-gpt-5.2-pro-2025-12-11-prompt": 952,
        "openAiUsage-gpt-5.2-pro-2025-12-11-completion": 119,
        "openAiUsage-o4-mini-2025-04-16-prompt": 13368,
        "openAiUsage-o4-mini-2025-04-16-completion": 3342,
        "openAiUsage-o4-mini-prompt": 13368,
        "openAiUsage-o4-mini-completion": 3342,
        "openAiUsage-gpt-4.1-2025-04-14-prompt": 10000,
        "openAiUsage-gpt-4.1-2025-04-14-completion": 2500,
        "openAiUsage-gpt-4.1-prompt": 10000,
        "openAiUsage-gpt-4.1-completion": 2500,
    },
};
/**
 * Default token-to-credit divisors for each token type.
 * The values are the number of tokens that a single Copilot Credit can pay for.
 * See https://docs.google.com/spreadsheets/d/1v_BhkiWvLnFmI-URtqzTkzHCYjgLxICPvVD3YC0Nz5Y/edit?gid=0#gid=0
 */
exports.defaultTokenDivisors = {
    // gpt-4-8k
    "openAiUsage-gpt-4-8k-prompt": 1515,
    "openAiUsage-gpt-4-8k-completion": 757,
    // gpt-4-32k
    "openAiUsage-gpt-4-32k-prompt": 757,
    "openAiUsage-gpt-4-32k-completion": 378,
    // gpt-4-1106-preview
    "openAiUsage-gpt-4-1106-preview-prompt": 4545,
    "openAiUsage-gpt-4-1106-preview-completion": 1515,
    // gpt-4-vision
    "openAiUsage-gpt-4-vision-prompt": 4545,
    "openAiUsage-gpt-4-vision-completion": 1515,
    // gpt-4-turbo
    "openAiUsage-gpt-4-turbo-prompt": 4545,
    "openAiUsage-gpt-4-turbo-completion": 1515,
    // gpt-4o
    "openAiUsage-gpt-4o-prompt": 3636,
    "openAiUsage-gpt-4o-prompt-cached": 3636,
    "openAiUsage-gpt-4o-completion": 909,
    // gpt-4o-2024-05-13
    "openAiUsage-gpt-4o-2024-05-13-prompt": 3636,
    "openAiUsage-gpt-4o-2024-05-13-prompt-cached": 3636,
    "openAiUsage-gpt-4o-2024-05-13-completion": 909,
    // gpt-4o-2024-08-06
    "openAiUsage-gpt-4o-2024-08-06-prompt": 3636,
    "openAiUsage-gpt-4o-2024-08-06-prompt-cached": 3636,
    "openAiUsage-gpt-4o-2024-08-06-completion": 909,
    // gpt-4o-mini-2024-07-18
    "openAiUsage-gpt-4o-mini-2024-07-18-prompt": 60606,
    "openAiUsage-gpt-4o-mini-2024-07-18-prompt-cached": 60606,
    "openAiUsage-gpt-4o-mini-2024-07-18-completion": 15151,
    // gpt-4o-mini
    "openAiUsage-gpt-4o-mini-prompt": 60606,
    "openAiUsage-gpt-4o-mini-prompt-cached": 60606,
    "openAiUsage-gpt-4o-mini-completion": 15151,
    // gpt-4
    "openAiUsage-gpt-4-prompt": 1515,
    "openAiUsage-gpt-4-completion": 757,
    // gpt-4.5-preview-2025-02-27
    "openAiUsage-gpt-4.5-preview-2025-02-27-prompt": 242,
    "openAiUsage-gpt-4.5-preview-2025-02-27-prompt-cached": 242,
    "openAiUsage-gpt-4.5-preview-2025-02-27-completion": 121,
    // gpt-4.5-preview
    "openAiUsage-gpt-4.5-preview-prompt": 242,
    "openAiUsage-gpt-4.5-preview-prompt-cached": 242,
    "openAiUsage-gpt-4.5-preview-completion": 121,
    // o3-mini-2025-01-31
    "openAiUsage-o3-mini-2025-01-31-prompt": 8264,
    "openAiUsage-o3-mini-2025-01-31-prompt-cached": 8264,
    "openAiUsage-o3-mini-2025-01-31-completion": 2066,
    // o3-mini
    "openAiUsage-o3-mini-prompt": 8264,
    "openAiUsage-o3-mini-prompt-cached": 8264,
    "openAiUsage-o3-mini-completion": 2066,
    // o3-2025-04-16
    "openAiUsage-o3-2025-04-16-prompt": 909,
    "openAiUsage-o3-2025-04-16-prompt-cached": 909,
    "openAiUsage-o3-2025-04-16-completion": 227,
    // o3
    "openAiUsage-o3-prompt": 909,
    "openAiUsage-o3-prompt-cached": 909,
    "openAiUsage-o3-completion": 227,
    // o4-mini-2025-04-16
    "openAiUsage-o4-mini-2025-04-16-prompt": 8264,
    "openAiUsage-o4-mini-2025-04-16-prompt-cached": 8264,
    "openAiUsage-o4-mini-2025-04-16-completion": 2066,
    // o4-mini
    "openAiUsage-o4-mini-prompt": 8264,
    "openAiUsage-o4-mini-prompt-cached": 8264,
    "openAiUsage-o4-mini-completion": 2066,
    // gpt-4.1-2025-04-14
    "openAiUsage-gpt-4.1-2025-04-14-prompt": 8771,
    "openAiUsage-gpt-4.1-2025-04-14-prompt-cached": 8771,
    "openAiUsage-gpt-4.1-2025-04-14-completion": 2192,
    // gpt-4.1
    "openAiUsage-gpt-4.1-prompt": 8771,
    "openAiUsage-gpt-4.1-prompt-cached": 8771,
    "openAiUsage-gpt-4.1-completion": 2192,
    // gpt-5-2025-08-07
    "openAiUsage-gpt-5-2025-08-07-prompt": 11428,
    "openAiUsage-gpt-5-2025-08-07-prompt-cached": 11428,
    "openAiUsage-gpt-5-2025-08-07-completion": 1428,
    // gpt-5.1-2025-11-13
    "openAiUsage-gpt-5.1-2025-11-13-prompt": 11428,
    "openAiUsage-gpt-5.1-2025-11-13-prompt-cached": 11428,
    "openAiUsage-gpt-5.1-2025-11-13-completion": 1428,
    // gpt-5.2-2025-12-11
    "openAiUsage-gpt-5.2-2025-12-11-prompt": 19704,
    "openAiUsage-gpt-5.2-2025-12-11-prompt-cached": 19704,
    "openAiUsage-gpt-5.2-2025-12-11-completion": 2463,
    // gpt-5.2-pro-2025-12-11
    "openAiUsage-gpt-5.2-pro-2025-12-11-prompt": 297,
    "openAiUsage-gpt-5.2-pro-2025-12-11-prompt-cached": 297,
    "openAiUsage-gpt-5.2-pro-2025-12-11-completion": 37,
    // gpt-5.1-codex-max
    "openAiUsage-gpt-5.1-codex-max-prompt": 5000,
    "openAiUsage-gpt-5.1-codex-max-prompt-cached": 5000,
    "openAiUsage-gpt-5.1-codex-max-completion": 625,
    // gpt-5-mini-2025-08-07
    "openAiUsage-gpt-5-mini-2025-08-07-prompt": 25000,
    "openAiUsage-gpt-5-mini-2025-08-07-prompt-cached": 25000,
    "openAiUsage-gpt-5-mini-2025-08-07-completion": 3125,
    // gpt-5-nano-2025-08-07
    "openAiUsage-gpt-5-nano-2025-08-07-prompt": 181818,
    "openAiUsage-gpt-5-nano-2025-08-07-prompt-cached": 181818,
    "openAiUsage-gpt-5-nano-2025-08-07-completion": 22727,
    // o1-2024-12-17
    "openAiUsage-o1-2024-12-17-prompt": 1212,
    "openAiUsage-o1-2024-12-17-prompt-cached": 1212,
    "openAiUsage-o1-2024-12-17-completion": 303,
    // o1-preview
    "openAiUsage-o1-preview-prompt": 1212,
    "openAiUsage-o1-preview-prompt-cached": 1212,
    "openAiUsage-o1-preview-completion": 303,
    // o1-mini
    "openAiUsage-o1-mini-prompt": 8264,
    "openAiUsage-o1-mini-prompt-cached": 8264,
    "openAiUsage-o1-mini-completion": 2066,
    // o1
    "openAiUsage-o1-prompt": 1212,
    "openAiUsage-o1-prompt-cached": 1212,
    "openAiUsage-o1-completion": 303,
    // ft:gpt-4o-2024-08-06
    "openAiUsage-ft:gpt-4o-2024-08-06-prompt": 3636,
    "openAiUsage-ft:gpt-4o-2024-08-06-prompt-cached": 3636,
    "openAiUsage-ft:gpt-4o-2024-08-06-completion": 1212,
    // ft:gpt-4o-mini-2024-07-18
    "openAiUsage-ft:gpt-4o-mini-2024-07-18-prompt": 151515,
    "openAiUsage-ft:gpt-4o-mini-2024-07-18-prompt-cached": 151515,
    "openAiUsage-ft:gpt-4o-mini-2024-07-18-completion": 37878,
    // ft:gpt-3.5-turbo
    "openAiUsage-ft:gpt-3.5-turbo-prompt": 15151,
    "openAiUsage-ft:gpt-3.5-turbo-completion": 7575,
    // Anthropic
    "anthropicUsage-claude-3-5-sonnet-20240620-prompt": 15151,
    "anthropicUsage-claude-3-5-sonnet-20240620-completion": 3030,
    "anthropicUsage-claude-3-opus-20240229-prompt": 3030,
    "anthropicUsage-claude-3-opus-20240229-completion": 606,
    "anthropicUsage-claude-3-sonnet-20240229-prompt": 15151,
    "anthropicUsage-claude-3-sonnet-20240229-completion": 3030,
    "anthropicUsage-claude-3-haiku-20240307-prompt": 181818,
    "anthropicUsage-claude-3-haiku-20240307-completion": 36363,
    "anthropicUsage-claude-3-opus-prompt": 3030,
    "anthropicUsage-claude-3-opus-completion": 606,
    "unknown-unknown-prompt": 1515,
    "unknown-unknown-completion": 757,
    /**
     * - DeepPcb Credit burn per hour: 10
     * - DeepPcb cost per credit: $1
     * - Flux cost per credit: $0.05
     * - Desired Markup: 1.5
     * - DeepPcb "tokens" per credit: 3000
     * - DeepPcb "tokens" consumed per hour: 30,000
     * - desired cost to Flux user: 10*1.5 = $15
     * - Flux credits per hour: 15 / 0.05 = 300
     *
     * We want to convert `DeepPcb "tokens" consumed per hour` to `Flux credits per hour`, so that the token divisor will be 30,000/300 = 100
     */
    "deep-pcb-auto-layout": 100,
};
//# sourceMappingURL=tokenDivisors.js.map